const makeDate = (offsetDays) => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + offsetDays);
  return date.toISOString().split("T")[0];
};

const buildBookedSlots = (entries) =>
  entries.reduce((accumulator, [offsetDays, lunch, dinner]) => {
    accumulator[makeDate(offsetDays)] = { lunch, dinner };
    return accumulator;
  }, {});

export const samplePublicBanquetDemo = {
  id: "sample-vintage-banquet",
  slug: "vintage-banquet-vasundhara-ghaziabad",
  status: "published",
  isActive: true,
  name: "Vintage Banquet | Luxury Banquet Hall in Vasundhara, Indirapuram, Ghaziabad",
  displayName: "Vintage Banquet",
  city: "Ghaziabad",
  locality: "Vasundhara",
  area: "Sector 9, Vasundhara",
  address: "CP-5, Sector 9, Vasundhara, Ghaziabad, Uttar Pradesh 201012",
  latitude: 28.663,
  longitude: 77.363,
  mapUrl: "https://share.google/3VbJf3w7PmWFBjrz7",
  googleRating: 4.3,
  googleRatingsTotal: 609,
  googleSourceLabel: "Verified Venue",
  shortDescription:
    "Luxury banquet hall in Vasundhara, Indirapuram, Ghaziabad for birthdays, engagements, anniversaries and premium family celebrations.",
  description:
    "Vintage Banquet is a luxury banquet hall in Vasundhara, Indirapuram, Ghaziabad. Customers can view venue media, pricing, capacity, food, decoration, alcohol, availability and easy enquiry actions.",
  guestMin: 100,
  guestMax: 300,
  vegPrice: 1200,
  nonVegPrice: 1500,
  foodType: "veg-non-veg",
  liquorAllowed: true,
  byobAllowed: false,
  parkingAvailable: true,
  parkingCapacity: 75,
  valetParking: true,
  roomsAvailable: true,
  roomCount: 10,
  bridalRoom: true,
  changingRoom: true,
  venueType: "Banquet Hall",
  indoorOutdoor: ["indoor", "rooftop"],
  acHall: true,
  powerBackup: true,
  lift: true,
  wheelchairFriendly: true,
  decorPolicy: "Decoration support available for birthday, first birthday, baby shower and anniversary events.",
  cateringPolicy: "In-house catering available with buffet and live counter options.",
  djAllowed: true,
  lateNightAllowed: false,
  eventTypes: ["birthday", "first birthday", "baby shower", "anniversary", "engagement", "corporate"],
  tags: ["Near Metro", "Large Parking", "Premium Venue", "Birthday Specialist"],
  facilities: [
    "AC Hall",
    "LED Wall",
    "DJ Setup",
    "WiFi",
    "CCTV",
    "Power Backup",
  ],
  highlights: ["Near Metro", "Large Parking", "Premium Venue", "Birthday Specialist"],
  goodFor: [
    "Birthday parties with balloon decoration",
    "First birthday celebrations",
    "Baby shower functions",
    "Anniversary dinners",
    "Premium family parties",
  ],
  notIdealFor: ["Outdoor lawn-only events", "Bookings below 100 guests", "Customers requiring owner direct contact"],
  basicDetails: {
    venueTypes: ["Banquet Hall", "Party Hall"],
  },
  locationDetails: {
    city: "Ghaziabad",
    locality: "Vasundhara",
    fullAddress: "CP-5, Sector 9, Vasundhara, Ghaziabad, Uttar Pradesh 201012",
    googleMapLink: "https://share.google/3VbJf3w7PmWFBjrz7",
  },
  capacityDetails: {
    seatingCapacity: 200,
    floatingCapacity: 300,
    minimumGuestRange: "100-125",
    halls: [
      {
        floor: "Ground Floor",
        hallName: "Royal Hall",
        minimumGuests: 100,
        maximumCapacity: 200,
        hallCapacity: 200,
      },
      {
        floor: "First Floor",
        hallName: "Orchid Hall",
        minimumGuests: 50,
        maximumCapacity: 100,
        hallCapacity: 100,
      },
    ],
    roomsAvailable: true,
    numberOfRooms: 10,
    complimentaryRoomAvailable: true,
    numberOfComplimentaryRooms: 2,
    bridalRoomAvailable: true,
    numberOfBridalRooms: 1,
    liftAvailable: true,
    passengerLiftCount: 2,
    wheelchairAccessible: true,
  },
  pricingDetails: {
    vegStartingFrom: 1200,
    nonVegStartingFrom: 1500,
    bookingAdvanceRequired: "Reserve your date with a small advance",
  },
  parkingDetails: {
    parkingAvailable: true,
    totalParkingCapacity: 75,
    valetParking: true,
    parkingTypes: ["Covered Parking"],
    parkingCharges: "Included for venue guests",
  },
  foodCatering: {
    inhouseCatering: true,
    outsideCateringAllowed: false,
    kitchenAvailable: true,
    foodServingStyle: "Buffet",
    liveCounters: ["Chaat Counter", "Pasta Counter", "Dessert Counter"],
    specialFoodServices: ["Inhouse Catering", "Live Counters", "Buffet"],
  },
  decorationServices: {
    inhouseDecoration: true,
    decorationTeam: "DecorZoom celebration styling team",
    outsideDecoratorAllowed: false,
    decorPackagesAvailable: true,
    decorationStartingPrice: 15000,
    decorationThemesAvailable: ["Balloon Decoration", "Ring Decoration", "Premium Luxury Setup"],
    decorationMaterialsAvailable: ["Balloons", "Ring backdrop", "LED name", "Premium props", "Stage florals"],
    additionalServicesAvailable: ["Birthday", "First Birthday", "Baby Shower", "Anniversary"],
  },
  alcoholPolicy: {
    alcoholAllowed: true,
    inhouseAlcoholAvailable: true,
    outsideAlcoholAllowed: false,
    liquorLicenseAvailable: true,
    corkageChargesApplicable: false,
    alcoholServiceAreas: ["Banquet Hall", "Rooftop"],
    barCounterAvailable: true,
    barType: "Licensed Venue Bar",
    bartenderAvailable: true,
  },
  timingDetails: {
    openingTime: "10:00 AM",
    closingTime: "11:30 PM",
    eventsSupported: ["Birthday", "First Birthday", "Baby Shower", "Anniversary"],
    fullDayEventAvailable: true,
    overnightEventAllowed: false,
    musicDjTimingLimit: "DJ and music allowed as per local venue guidelines",
  },
  media: {
    coverPhotos: [
      { url: "/images/banquets/vintage-banquet/vintage-banquet-1.jpg" },
      { url: "/images/banquets/vintage-banquet/vintage-banquet-2.jpg" },
      { url: "/images/banquets/vintage-banquet/vintage-banquet-3.webp" },
    ],
    galleryPhotos: [
      { url: "/images/banquets/vintage-banquet/vintage-banquet-1.jpg" },
      { url: "/images/banquets/vintage-banquet/vintage-banquet-2.jpg" },
      { url: "/images/banquets/vintage-banquet/vintage-banquet-3.webp" },
      { url: "/images/banquets/vintage-banquet/vintage-banquet-4.webp" },
      { url: "/images/banquets/vintage-banquet/vintage-banquet-5.webp" },
    ],
    videoTeasers: [],
    droneVideos: [],
    tour360: {
      link: "",
    },
  },
  images: [
    "/images/banquets/vintage-banquet/vintage-banquet-1.jpg",
    "/images/banquets/vintage-banquet/vintage-banquet-2.jpg",
    "/images/banquets/vintage-banquet/vintage-banquet-3.webp",
    "/images/banquets/vintage-banquet/vintage-banquet-4.webp",
    "/images/banquets/vintage-banquet/vintage-banquet-5.webp",
  ],
  availabilityCalendar: {
    showToPublic: true,
    dates: {
      [makeDate(0)]: "available",
      [makeDate(1)]: "available",
      [makeDate(2)]: "lunchBooked",
      [makeDate(3)]: "available",
      [makeDate(4)]: "fullyBooked",
      [makeDate(5)]: "dinnerBooked",
    },
    bookedSlots: buildBookedSlots([
      [2, true, false],
      [4, true, true],
      [5, false, true],
      [8, true, false],
      [11, false, true],
      [15, true, true],
      [19, true, false],
      [24, false, true],
    ]),
  },
};
